import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { ScanSelectionTreeModule } from '../scan-selection-tree/scan-selection-tree.module';
import { Crp1ScanSelectComponent } from './crp1-scan-select.component';

@NgModule({
    imports: [CommonModule, FormsModule, TwcModule, TranslateModule, ScanSelectionTreeModule],
    exports: [Crp1ScanSelectComponent],
    declarations: [Crp1ScanSelectComponent],
})
export class Crp1ScanSelectModule {}
